import React from 'react';
import PropTypes from 'prop-types';

const ServiceCard = ({ btnText, img, label, title, caption }) => {
  return (
    <div className="w-full flex flex-col gap-10 justify-center items-center md:flex-row md:gap-0">
      <div className="w-full md:w-[45%]">
        <label className="block text-primary">{label}</label>
        <h1 className="text-light font-medium text-4xl mt-2">{title}</h1>
        <div className="mt-4">
          <p className="text-obsidian w-1/2">{caption}</p>
        </div>
        <div className="mt-4">
          <a
            href="https://app.bafancy.com"
            target="_blank"
            rel="noreferrer"
            className="primary-btn">
            {btnText}
          </a>
        </div>
      </div>
      <div className="w-full md:w-[45%]">
        <img src={img} alt="" className="w-full" />
      </div>
    </div>
  );
};

export default ServiceCard;

ServiceCard.propTypes = {
  img: PropTypes.any,
  label: PropTypes.string,
  title: PropTypes.string,
  caption: PropTypes.string,
  btnText: PropTypes.string
};
